// Shared layout chrome constants used by both products' app shells and
// by auth flows (which add bottom padding so login/signup forms aren't
// hidden behind the mobile nav bar).
export const MOBILE_NAV_HEIGHT = "60px";
